import { omit } from 'lodash';
import { PaymentOptionDetailModel } from '@/helpers/entities/models/PaymentOptionDetailModel';
import { PaymentOptionBankDetailModel } from '@/helpers/entities/models/PaymentOptionBankDetailModel';
export class PaymentOptionModel {
    constructor(payload) {
        Object.assign(this, omit(payload, 'optionDetails'));
        this.details = payload.optionDetails.edges.map((detail) => {
            return new PaymentOptionDetailModel(detail.node);
        });
        this.bankDetails = payload.bankDetails.edges.map((detail) => {
            return new PaymentOptionBankDetailModel(detail.node);
        });
    }
}
